webpackJsonp([120265229327411],{

/***/ 1416:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CustomLocationAttributeInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-custom-location-attribute-input-d53d72fa5d24d6cb39ca.js